<template>
	<div>
		<div class="modal__content">
			<p class="text-center mb20">{{content}}</p>

			<div class="flex flex--justify-center">
				<a class="btn btn--wide":href="link" :class="{'btn--disabled': linkDisabled}" download :disabled="linkDisabled" @click="$bus.$emit('modalClose')">Download</a>
			</div>
		</div>
	</div>
</template>

<script>
import { errorMessage } from 'modules/Error'
import { apiPingJob } from '@/api/project.api'

export default {
  data () {
    return {
      content: 'Your zip is getting ready',
      linkDisabled: true,
      link: ''
    }
  },

  created () {
  },

  props: {
    args: {
      projectId: null,
      taskId: null
    }
  },

  mounted () {
    this.pingJob()
  },

  methods: {
    async pingJob () {
      const { projectId, taskId } = this.args
      const [err, data] = await apiPingJob(projectId, taskId)
      if (err) return errorMessage(err, 'Failed to ping Koncepted') 

      if (data.success && data.zipCreated) {
        this.content = 'Your zip is ready'
        this.linkDisabled = false
        this.link = '/serve/s/' + data.linkToZip
        return this.$bus.$emit('downloadZipLink', taskId, data.linkToZip)
      } 
      
      if (data.success && !data.designerFilesUploaded) {
        this.$bus.$emit('modalClose')
        return this.$bus.$emit('toastError', 'No designer files on task')
      }
      
      return setTimeout(this.pingJob.bind(this), 1000) // TODO check this bind
    }
  }
}
</script>



// WEBPACK FOOTER //
// DownloadZipModal.vue?18ee6b88